export const ITEMS_PER_PAGE = 5;
export const RENTALS_PER_PAGE = 5;